<template>
  <div class="issues">
    <div class="level table-actions">
      <div class="level-left">
        <form @submit.prevent="onSearch">
          <div class="field is-grouped controls">
            <div class="control">
              <b-input v-model="q" :placeholder="$t('interface.search')"></b-input>
            </div>
            <div class="control">
              <button type="submit" class="button is-primary">
                <b-icon icon="magnify" size="is-small"></b-icon>
              </button>
            </div>
          </div>
        </form>
      </div>
      <div class="level-right">
        <div class="field is-grouped controls">
          <div class="control">
            <button @click="goTo('createIssue')"
                    class="button is-success">
              {{ $t('issues.create') }}
            </button>
          </div>
          <div class="control">
            <button @click="removeSelected"
                    :disabled="checkedRows.length === 0"
                    class="button is-danger">
              {{ $t('interface.removeSelected') }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <b-table class="mt-10"
             :data="list"
             :loading="loading"

             paginated
             backend-pagination
             :total="total"
             :per-page="perPage"
             @page-change="onPageChange"

             backend-sorting
             default-sort-direction="desc"
             :default-sort="[sortField, sortOrder]"
             @sort="onSort"

             checkable
             :checked-rows.sync="checkedRows"

             detailed
             detail-key="id">
      <template slot-scope="props">
        <b-table-column label="№" field="order_num" sortable>
          {{ props.row.order_num }}
        </b-table-column>
        <b-table-column :label="$t('issues.title')" field="name" sortable>
          {{ props.row.name }}
        </b-table-column>
        <b-table-column :label="$t('issues.state')" field="state" sortable>
          {{ $t(`projectControl.issueStatuses.${props.row.state}`) }}
        </b-table-column>
        <b-table-column :label="$t('issues.employee')" field="employee" sortable>
          {{ props.row.employee__name }}
        </b-table-column>
        <b-table-column :label="$t('issues.department')" field="department" sortable>
          {{ props.row.department__name }}
        </b-table-column>
        <b-table-column :label="$t('issues.term')" field="term_date" sortable>
          {{ props.row.term_date | localedDateWithYear }}
        </b-table-column>
        <b-table-column>
          <a @click="edit(props.row.id)">
            <b-icon icon="pencil" size="is-small" class="icon"></b-icon>
            {{ $t('interface.edit') }}
          </a>
        </b-table-column>
      </template>

      <template slot="detail" slot-scope="props">
        <p><b>Дата начала</b> {{ props.row.start_date | localedDateWithYear }}</p>
        <p v-if="props.row.started_date">
          <b>Фактическая дата начала</b> {{ props.row.started_date | localedDateWithYear }}
        </p>
        <p v-if="props.row.completed_date">
          <b>Дата окончания</b> {{ props.row.completed_date | localedDateWithYear }}
        </p>
        <p>
          <b>Описание</b><br>
          {{ props.row.description !== '' ? props.row.description : 'Описание отсутсвует.' }}
        </p>
      </template>

      <template slot="empty">
        <section class="section">
          <div class="content is-fluid has-text-grey has-text-centered">
            <p>
              <span class="has-text-grey-light">Ничего не найдено, попробуйте </span>
              <a @click.prevent="resetFilters">сбросить фильтры и поиск</a>.
            </p>
          </div>
        </section>
      </template>
    </b-table>
  </div>
</template>

<script>
  import {mapState} from 'vuex'

  export default {
    data() {
      return {
        total: 0,
        page: 1,
        perPage: 15,
        q: '',
        sortField: '',
        sortOrder: 'desc',
        checkedRows: []
      }
    },
    methods: {
      loadData() {
        this.checkedRows = []
        this.$store.dispatch('Issue/getList', {
          params: {
            page: this.page,
            page_size: this.perPage,
            q: this.q,
            ordering: `${this.sortOrder === 'desc' ? '-' : ''}${this.sortField}`
          },
          projectId: this.$route.params.projectId
        }).then(data => {
          this.total = data.count
        })
      },
      onSort(field, order) {
        this.sortField = field
        this.sortOrder = order
        this.loadData()
      },
      onPageChange(page) {
        this.page = page
        this.loadData()
      },
      onSearch() {
        this.loadData()
      },
      resetFilters() {
        this.q = ''
        this.loadData()
      },
      goTo(route) {
        this.$router.push({name: route})
      },
      edit(id) {
        this.$router.push({
          name: 'editIssue',
          params: {projectId: this.$route.params.projectId, issueId: id}
        })
      },
      removeSelected() {
        this.$dialog.confirm({
          title: this.$t('interface.dataDeleting'),
          message: this.$t('interface.dataDeletingMessage'),
          confirmText: this.$t('interface.dataDeleting'),
          cancelText: this.$t('interface.cancel'),
          type: 'is-danger',
          onConfirm: () => {
            this.checkedRows.map(row => {
              this.$store.dispatch('Issue/remove', {
                projectId: this.$route.params.projectId,
                issueId: row.id
              }).then(() => this.loadData())
            })
          }
        })
      }
    },
    mounted() {
      this.loadData()
    },
    computed: {
      ...mapState('Issue', ['list', 'loading'])
    }
  }
</script>